import { Theme, css } from "@emotion/react";

export const baseModal = (theme: Theme) => css`
  & > div:last-of-type > button:first-of-type {
    ${theme.button.secondarySmall};
    width: inherit;
  }
`;
